import {inject} from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ModulesEnum } from '../models/modules';

export const authGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isLoggedIn()) {
    return true;
  }

  // Redirect to the login page
  return router.parseUrl(`/${ModulesEnum.Auth}`);
};

export const adminGuard = () =>{
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.canViewAdmin()) {
    return true;
  }

  // Redirect to the Dashboard page
  return router.parseUrl(`/${ModulesEnum.Dashboard}`);
}
